import React, { Component } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./MainScreen.scss";

export default class GenericEnd extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className="section section-welcome">
                <Header />
                <div className="padding">
                    <div className="container">
                        <div className="headline">
                            <div className="head">מצעד כוכבי הרשת של</div>
                            <div className="logo"></div>
                            <div className="slogen">
                                <div className="text">אתר הנוער של ישראל</div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Screen/GenericEnd.jsx